<p><span><span style="color: #404040;"><span><span lang="en-GB"><strong>Conversion rate:</strong></span></span></span></span></p>
<ul>
  <li>
    <p>
      <span
        ><span style="color: #00b0f0;"><span><span lang="en-GB"><strong>Target</strong></span></span></span><span style="color: #00b0f0;"
          ><span><span lang="en-GB">: </span></span></span
        ><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >If YTD is selected: Target for the Conversion rate p.m. for the current year (=target for annual Conversion rate / 12). Else:
              Target for annual conversion rate in the year of the selected timeframe.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span
        ><span style="color: #404040;"><span><span lang="en-GB"><strong>Actual</strong></span></span></span><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >: If YTD is selected: Actual average conversion rate p.m. (based on all months YTD). Else: Conversion rate p.a. in the
              selected year.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span style="color: #92d050;">●</span><span
        ><span style="color: #404040;"><span><span lang="en-GB">/</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">: The icon indicates, whether the target is met (</span></span></span><span
          style="color: #92d050;"><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">) or missed (</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">)</span></span></span></span
      >
    </p>
  </li>
</ul>
<p>
  <span
    ><span style="color: #7f7f7f;"
      ><span><span lang="en-GB"><em><span style="text-decoration: underline;">Calculation of the Conversion rate</span></em></span></span
      ></span
    ><span style="color: #7f7f7f;"
      ><span
        ><span lang="en-GB"
          ><em>: Total number of new customers in timeframe / Total number of all leads open within the reporting timeframe</em></span
        ></span
      ></span
    ></span
  >
</p>
<p lang="en-GB">&nbsp;</p>
<p><span><span style="color: #404040;"><span><span lang="en-GB"><strong>Cow Acquisition Cost:</strong></span></span></span></span></p>
<ul>
  <li>
    <p>
      <span
        ><span style="color: #00b0f0;"><span><span lang="en-GB"><strong>Target</strong></span></span></span><span style="color: #00b0f0;"
          ><span><span lang="en-GB">: </span></span></span
        ><span style="color: #404040;"
          ><span><span lang="en-GB">Target for total cost of acquisition per cow in the year of the selected timeframe</span></span></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span
        ><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >Actual: Actual cost of acquisition per cow YTD (if timeframe = current year YTD) or in the full year (if a previous year is
              selected as reporting timeframe)</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span style="color: #92d050;">●</span><span
        ><span style="color: #404040;"><span><span lang="en-GB">/</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">: The icon indicates whether the target is met (</span></span></span><span
          style="color: #92d050;"><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">) or missed (</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">)</span></span></span></span
      >
    </p>
  </li>
</ul>
<p>
  <span
    ><span style="color: #7f7f7f;"
      ><span
        ><span lang="en-GB"><em><span style="text-decoration: underline;">Calculation of the Cow Acquisition Cost</span></em></span></span
      ></span
    ><span style="color: #7f7f7f;"
      ><span
        ><span lang="en-GB"
          ><em
            >: Total cost of acquisition (marketing and sales costs) within timeframe (at day level) / total number of new boluses of new
            customers within same timeframe</em
          ></span
        ></span
      ></span
    ></span
  >
</p>
<p lang="en-GB">&nbsp;</p>
<p><span><span style="color: #404040;"><span><span lang="en-GB">Chart:</span></span></span></span></p>
<p>
  <span style="color: #404040;"
    ><span
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAICAYAAABte3YfAAAAr0lEQVR4nNWSMQ7CMAxFndZhIS3X4DgsLByQhYXjcAAEM21YsBODK0WtuoGiVPzJX+9L/w9GEYGcYgHsWZrkPYujCFbvAFB3JG1izyDrV4TVwOTDeMJ4ZBGgepBsEsPznXbHKx3UaJmW6q1FPohLwSnjOBsWxmElhBcft6cb7UsV5hAuPeAXoQHI+9QFhK013dIjvtV/vkfpQlsBudr45Bs0PVbAwxgDrD4xzWl+zt4sZFSMsyec0AAAAABJRU5ErkJggg=="
            alt=""
          />&nbsp;&nbsp; Target for conversion rate p.m.</span
        ></span
      ></span
    ></span
  >
</p>
<div class="p" style="position: relative;">
  <span style="color: #404040;"
    ><span
      ><span
        ><span lang="en-GB"
          ><img
            style="left: 0; top: 50%; width:15px; position: absolute;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAICAYAAABte3YfAAAA5ElEQVR4nNXSTW7CMBAF4OJ4bAcKbW/DkiU34kxdddVbICEEUqtKPUR//BM7njTPggNQEUW81TeO5HlKIruuuxsq/d0T6+zjef5x9ulsnON5sXcPzJ2AXXALZq5g7/08c5bFIdy3ORMs9+/H1fawWzcx1jElg8OUosFc3Cbde3qyCk0zg3NuCRfBWGKDX5SizAIlBnsTKP32+bF8fn3ZDLnk2pFjF/hPpCblxy5xaWSfOHaJS3Obv4dR2g29ZFZPvyZCcLGpv4UQGa6N+a0qmWCjtSVJ5atrpVzv5mRPpAKsiALmP4wAb3ltYrGCAAAAAElFTkSuQmCC"
            alt=""
          /><img
            style="top:6px; left:2px; height:7px; position: absolute;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAABXUlEQVR4nGP5//8/Ay5w+fodW11NlcPY5Fhwadqw/UDu1HmrJ2UnheYFeDpMJkrjnkOnYqfNXzMRxAbRPNxcH1zszBbj1Xj8zCW/7qmL5wO9wAjig2gQn5uL46Olid4mrBovXLnp1NQ7d/W/f/+YkcVBfJB4e3WWp4GO+j4UjTduPzCv65y58c+fP2zYnA8SB8l31eW5aKgqnARrvP/omW51+7St33/85MGmCQZA8iB1PQ0FjizPXrxWqWqduv3T56/C+DTBAEgdSD3O6CAEWKQkRO+0VWd7ljRM2E+MrXy83G9B6sE2KspJXW6tzPIua5q0B58/OTnYv4DUgdTDnQoKqabydP/K1mnbsYUsCwvLL5A8SB2YjywJiqO64uTQhu7Z65DjkomJ6S9IHBaHGBpBAJQ6SrNjE7umLFoISjVA8B/ER041WDWCAChdfvn6TQCUyLMSQ/LR0ykIAACawqr1XnW92AAAAABJRU5ErkJggg=="
            alt=""
          />&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Conversion rate per month</span
        ></span
      ></span
    ></span
  >
</div>
<p>
  <span style="color: #404040;"
    ><span
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAHCAYAAAB3Gn/JAAAA/0lEQVR4nGP5+esXx69fPzkZkMDff/+Yv/34zicqKPyEhYXlFwMaAOrhfPTssRa6OFAPL0iPlLjkHXQ5EDh75YLb1+/f+NHF//79y+JoYbscm57rd29ZXLpx1R5dnGXdrs0F81YvacemaWZLv56ijPxldPG3H95JZTeUnsGmJ8I7qCMpNKYSm9zCdSuabty7ZY4uLiYs8giXw6/evmE9d/XiDgyHY1NMCLAws/wmSx8LM8n62NnYvmE1C58mYBSykmoRvQBeh//4+ZOLVAO//vjGR6qeb9+/k6yHrKSCF/xnYCRZy///JOthYWdl+06qJiYmpr+k6gHrYyRPHzYAAHx9W6a15OrvAAAAAElFTkSuQmCC"
            alt=""
          />&nbsp;&nbsp;&nbsp; Average conversion rate p.m.</span
        ></span
      ></span
    ></span
  >
</p>
<div class="p" style="position:relative;">
  <span style="color: #404040;"
    ><span
      ><span
        ><span lang="en-GB"
          ><img
            style="left: 0; top: 50%; width:15px; position: absolute;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAHCAYAAABz76/0AAAAR0lEQVR4nGP5/v27AhCrMBAB/v79y/3//382ItVy/fv3j50YtUB1RKtlefXqVcS9e/faiVE8GADLQDuAVDDqYFqDUQfTGgAAGBUebk2tkNoAAAAASUVORK5CYII="
            alt=""
          /><img
            style="top:6px; left:2px; height:7px; position: absolute;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAABgUlEQVR4nGP5//8/Aw7A+PHjRyt+fv6j2CRZcOm6d+9e26NHj8o1NDQSJSQkFhKlEaihAoRB7Js3b85lYmL6LiYmtgqvxmfPnqWDbIPxgV5hvn79+mJmZubvwsLCm7FqfPXqVfjt27engvyHLA7UzHb16tXVurq6voKCgrtRNL57984DaPIikA3YnP/v3z/2y5cvb9DX1/cABthhsEZQ6F25cmUtyGRsmpA0cwE1b9bT03Nj+fr1qw6Qsw0kiE8TDPz584f/0qVLO1jY2NhesrKyvgYJEKMRBIDq37KANAGt9jx37tyx379/ixLSxM7O/gToTxewHzk5Oe8AOW4XLlw4gM9mkCVAda4cHBwP4aHKw8NzQVtbOwjo/u3YAomFheUjyGVcXFw3wHxkSWAc7dPS0oq6du3aSuRoAaacbzo6Ov68vLxn4QahmywqKrpWVVU199atW9NAfEZGxl9Al4QLCAgcRHEBNr9ISUlN//Xrl/jDhw9rNDU1E4BJbQu6GgBscKhIxFjRyAAAAABJRU5ErkJggg=="
            alt=""
          /> &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Conversion rate per month previous year</span
        ></span
      ></span
    ></span
  >
</div>
<p>
  <span style="color: #404040;"
    ><span
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAHCAYAAACcLcTKAAAAvElEQVR4nGP5/PmzwadPn8z+///P/vfvXy4GJCAqKrqGk5PzLgMW8OTJk4J///6xo4uzsLB8kpKSmo5Nz9evX7Xevn3ri01OQEDgIB8f3wlsci9fvoz++fOnDNyOd+/eedy7d68dm2Jubu4ruBz94MGDhj9//vCji7Ozsz/C5egvX74YAO3qwCanpKRUicvRz549y/j48aMN3NHYFBEDGBkZf5Grl1JAtqOZmJi+U9MhpACyHT2QYNTR9AIAuWREeP0bNvAAAAAASUVORK5CYII="
            alt=""
          />&nbsp;&nbsp;&nbsp; Average conversion rate p.m. previous year</span
        ></span
      ></span
    ></span
  >
</p>
<p>&nbsp;</p>
<p>
  <span style="color: #404040;"
    ><span
      ><span><span lang="en-GB"><img style="height:12px; background-color: #AFC5B9;" />&nbsp; Cow acquisition cost p.m.</span></span></span
    ></span
  >
</p>
<p>
  <span style="color: #404040;"
    ><span
      ><span
        ><span lang="en-GB"
          ><img
            style="height:12px;"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAGElEQVR4nGO5efPmfwY8gAWf5KgCEhQAAB9aA7c57FzIAAAAAElFTkSuQmCC"
            alt=""
          />&nbsp; Cow acquisition cost p.m. previous year</span
        ></span
      ></span
    ></span
  >
</p>
<p>&nbsp;</p>
<p lang="en-US">&nbsp;</p>

<style>
  p {
    padding: 0;
    margin: 0;
  }

  img {
    width: 11px;
    height: 2px;
  }
</style>
